import { RightSidebarState } from "../../Models/RightSidebarState";
import {
  CLOSE_RIGHT_SIDEBAR,
  FETCH_SASURL_FAILURE,
  FETCH_SASURL_NEW_WINDOW_SUCCESS,
  FETCH_SASURL_REQUEST,
  FETCH_SASURL_SUCCESS,
  OPEN_RIGHT_SIDEBAR,
  TOGGLE_RIGHT_SIDEBAR,
} from "./RightSidebarTypes";

const initialState: RightSidebarState = {
  isOpen: false,
  pdfUrl: "pdf/loader.pdf",
  loading: false,
  error: null,
};

const RightSidebarReducer = (state = initialState, action: any): RightSidebarState => {
  switch (action.type) {
    case OPEN_RIGHT_SIDEBAR:
      return { ...state, isOpen: true };
    case CLOSE_RIGHT_SIDEBAR:
      return { ...state, isOpen: false };
    case TOGGLE_RIGHT_SIDEBAR:
      return { ...state, isOpen: !state.isOpen };
    case FETCH_SASURL_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SASURL_SUCCESS:
      return { ...state, loading: false, isOpen: state.isOpen ? true : !state.isOpen, pdfUrl: action.payload };
    case FETCH_SASURL_NEW_WINDOW_SUCCESS:
      return { ...state, loading: false, pdfUrl: action.payload };
    case FETCH_SASURL_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default RightSidebarReducer;
